// ---- MEDIA UNLOCK ----
let mediaUnlocked = false;

function unlockMediaPlayback() {
    if (mediaUnlocked) return;
    mediaUnlocked = true;

    const vids = document.querySelectorAll('video');
    vids.forEach(v => {
        v.muted = true;
        v.play().then(() => {
            v.pause();
            v.currentTime = 0;
        }).catch(()=>{});
    });
}

window.addEventListener('touchstart', unlockMediaPlayback, { once: true });
window.addEventListener('mousedown', unlockMediaPlayback, { once: true });


// ---- TABS ----
export function initTabs() {
    const tabs = document.querySelectorAll('.boxes__tab');
    const items = document.querySelectorAll('.boxes__item');

    if (!tabs.length) return;

    // Повна зупинка всіх відео
    function stopAllVideos() {
        const videos = document.querySelectorAll('.boxes__item video');
        videos.forEach(video => {
            video.pause();
            video.currentTime = 0;
        });
    }

    // Запуск відео у активному табі
    function playActiveVideo(target) {
        const activeItem = document.querySelector(`.boxes__item[data-box="${target}"]`);
        if (!activeItem) return;

        const video = activeItem.querySelector('video');
        if (!video) return;

        video.muted = true;
        video.playsInline = true;
        video.webkitPlaysInline = true;

        // ПОВНЕ примусове оновлення бафера
        video.load();

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                video.play().catch(() => {});
            });
        });
    }

    tabs.forEach(tab => {
        tab.addEventListener('click', () => {
            const target = tab.dataset.box;

            tabs.forEach(t => t.classList.remove('active'));
            tab.classList.add('active');

            items.forEach(item => {
                item.classList.toggle('active', item.dataset.box === target);
            });

            stopAllVideos();
            playActiveVideo(target);
        });
    });

    // autoplay першого таба
    window.addEventListener('load', () => {
        const firstTab = document.querySelector('.boxes__tab.active');
        if (firstTab) playActiveVideo(firstTab.dataset.box);
    });

    // Автозапуск першого табу коли він став видимим
    function autoPlayWhenVisible() {
        const activeVideo = document.querySelector('.boxes__item.active video');
        if (!activeVideo) return;

        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    activeVideo.muted = true;
                    activeVideo.play().catch(() => {});
                    observer.disconnect();
                }
            });
        }, {
            threshold: 0.25,
        });

        observer.observe(activeVideo);
    }

    window.addEventListener('DOMContentLoaded', autoPlayWhenVisible);

    function setAdaptiveMinHeight() {
        const boxesImages = document.querySelectorAll('.boxes__image');
        if (!boxesImages.length) return;

        const width = window.innerWidth;

        // Якщо ширше 480px — скидаємо мінімальну висоту і виходимо
        if (width > 480) {
            boxesImages.forEach(img => img.style.minHeight = '');
            return;
        }

        // Нижче 480px — задаємо адаптивну висоту
        let minHeight;

        if (width > 390) {
            minHeight = 240;
        } else if (width > 325) {
            minHeight = 220;
        } else {
            minHeight = 190;
        }

        boxesImages.forEach(img => {
            img.style.minHeight = `${minHeight}px`;
        });
    }

// Запускаємо при завантаженні і ресайзі
    window.addEventListener('load', setAdaptiveMinHeight);
    window.addEventListener('resize', setAdaptiveMinHeight);

}
